import { render } from "./DatatableSearch.vue?vue&type=template&id=b2911c50"
import script from "./DatatableSearch.vue?vue&type=script&lang=js"
export * from "./DatatableSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Tables/DatatableSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2911c50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2911c50', __exports__)) {
    api.reload('b2911c50', __exports__)
  }
  
  module.hot.accept("./DatatableSearch.vue?vue&type=template&id=b2911c50", () => {
    api.rerender('b2911c50', render)
  })

}


export default __exports__